/**
 * The default number of items to display in a searchable filter list.
 */
export const DEFAULT_SEARCH_LIST_SIZE = 100;

export const URL_PARAM_MAP: Record<string, string> = {
    professions: 'profession',
    professionals: 'company',
    libraryRanges: 'productRanges',
    sortBy: 'sort',
    isPurchasable: 'forSale',
    category: 'categoryLink',
    state: 'location-state',
};
